import { Link } from "react-router-dom";

interface Props {
  projectId: string;
  projectCode: string;
  projectName: string;
  customerName: string | null;
}

/**
 * Liten chip som viser project_code + kunde — klikkbar lenke til
 * prosjektkortet. Brukes ved hver innboks-rad så PL ser kontekst uten
 * å åpne prosjektet.
 */
export function ProjectChip({ projectId, projectCode, projectName, customerName }: Props) {
  const label = customerName ? `${customerName} — ${projectName}` : projectName;
  return (
    <Link
      to={`/prosjekter/${projectId}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border border-border bg-muted/30 text-[11px] tabular-nums hover:bg-muted transition-colors max-w-[260px]"
      onClick={(e) => e.stopPropagation()}
    >
      <span className="text-primary font-semibold">{projectCode}</span>
      <span className="text-muted-foreground truncate">{label}</span>
    </Link>
  );
}
